import { Elements } from '@tfo/common'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useScimStyles } from './scimShared'

const { Paragraph } = Elements

type Props = {
  errorKey: string | null
}

export const ScimConfirmEnableView: React.FC<Props> = ({ errorKey }) => {
  const intl = useIntl()
  const styles = useScimStyles()
  return (
    <>
      <Paragraph>{intl.formatMessage({ id: 'sso.scim.confirmEnable.description' })}</Paragraph>
      <div className={styles.infoPanel}>
        <ul className={styles.infoPanelList}>
          <li>{intl.formatMessage({ id: 'sso.scim.confirmEnable.bullet1' })}</li>
          <li>{intl.formatMessage({ id: 'sso.scim.confirmEnable.bullet2' })}</li>
          <li>{intl.formatMessage({ id: 'sso.scim.confirmEnable.bullet3' })}</li>
        </ul>
      </div>
      {errorKey && <Paragraph className={styles.errorText}>{intl.formatMessage({ id: errorKey })}</Paragraph>}
    </>
  )
}
